// api.service.ts
import { Injectable } from '@angular/core';
import axios, { AxiosInstance } from 'axios';
import { environment } from '../../environments/environment';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { Router } from '@angular/router';

interface AuthResponse {
    id: string;
    accessToken: string;
    refreshToken: string;
    submissionId: string;
    taskId: string;
}

const REFRESH_URL = '/api/auth-exchange/v1/refresh-cookie';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    private axiosInstance: AxiosInstance;

    constructor(private router: Router) {
        this.axiosInstance = axios.create({
            baseURL: environment.API_BASE_URL,
            headers: {
                'Content-Type': 'application/json',
            },
            withCredentials: true,
        });

        // this.setupInterceptors();
    }

    get instance(): AxiosInstance {
        return this.axiosInstance;
    }

    // Endpoint returns two cookies (one with accessToken and one with refreshToken)
    // It also returns the accessToken and refreshToken as part of it's response body
    // although those values are not used in this app currenty because it depends on
    // cookie authentication instead.
    refreshAuth = (): Promise<AuthResponse> => {
        return new Promise((resolve, reject) => {
            this.instance
                .post<AuthResponse>(REFRESH_URL, null, {
                    withCredentials: true,
                })
                .then(resp => {
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    };

    // private setupInterceptors(): void {
    //     // Request interceptor
    //     this.axiosInstance.interceptors.request.use(
    //         config => {
    //             return config;
    //         },
    //         error => {
    //             return Promise.reject(error);
    //         }
    //     );

    //     this.axiosInstance.interceptors.response.use(
    //         response => {
    //             return response;
    //         },
    //         error => {
    //             if (error.response?.status !== 200 && error.config?.url?.includes(REFRESH_URL)) {
    //                 this.router.navigate(['/unauthorized'], {
    //                     queryParams: {
    //                         code: error.response.status,
    //                     },
    //                 });
    //             }
    //             if (error.response?.status === 403) {
    //                 this.router.navigate(['/unauthorized'], {
    //                     queryParams: {
    //                         code: error.response.status,
    //                         response: JSON.stringify(error.response),
    //                     },
    //                 });
    //             }
    //             return Promise.reject(error);
    //         }
    //     );

    //     createAuthRefreshInterceptor(this.axiosInstance, this.refreshAuth);
    // }
}
